import { render, staticRenderFns } from "./TrainingRecords.vue?vue&type=template&id=097136d6&scoped=true"
import script from "./TrainingRecords.vue?vue&type=script&lang=js"
export * from "./TrainingRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097136d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097136d6')) {
      api.createRecord('097136d6', component.options)
    } else {
      api.reload('097136d6', component.options)
    }
    module.hot.accept("./TrainingRecords.vue?vue&type=template&id=097136d6&scoped=true", function () {
      api.rerender('097136d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeDetails/components/TrainingRecords.vue"
export default component.exports